var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs-12":"","sm8":"","offset-sm2":"","text-xs-center":""}},[_c('h3',{staticClass:"display-1 font-weight-bold mb-3"},[_vm._v("\n    Predict AAT\n  ")]),_c('h3',[_vm._v("Friedrich Kueppers, M.D.")])])}
var staticRenderFns = []

export { render, staticRenderFns }